import { TemplateRef } from '@angular/core';
import { RR_TABLE_ACTION_BEHAVIOUR_TYPE } from '../../enum/table/table-action-behaviour-type.enum';

export interface RRIBaseTableActionSettings {
  behaviourType: RR_TABLE_ACTION_BEHAVIOUR_TYPE;
  showInColumn: boolean;
  order?: number;
  icon?: string;
  tooltip?: string;
  customType?: string;
  doNothing?: boolean;
  hide?: boolean;
  template?: TemplateRef<any>;
}
